<button nz-button nz-tooltip nzType="info" (click)="initializeESigning()" [disabled]="disabled">
    <span nz-icon nzType="signature" nzTheme="outline"></span> {{ (mergeMode ? 'Apvienot izvēlētos' : 'Parakstīt') }}
</button>
